import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIHomepageAdView } from '../ui_html/home_page/UIHomepageAdView.ts';
import { ArrayUtils } from '../../../../shared/utils/ArrayUtils.ts';
import { ViewPopupLogin } from '../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { HolidayDateUtils } from '../../../shared/scripts/HolidayDateUtils.ts';
import { AnalyticEventCategory, AnalyticEventType, GiftMembershipMethod } from '../../../../shared/entity_datas/EntityDatas.ts';
import { getHomepageUrlWithParameter, navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { BotsMatchType } from '@colonist/game-base-types';
import { UIUrlParameterNames } from '../../../shared/scripts/ui_html/UIUrlController.ts';
import { showRushRulesDialog } from '../../../shared/scripts/ui_popup/showRushRulesDialog.ts';
import { sendRushAdClicked, sendRushAdImpression } from '../../../shared/scripts/analytics/sendRushAdAnalytic.ts';
import AbFullscreen from '@static/images/ab_fullscreen.png';
import AbMembership from '@static/images/ab_membership.png';
import AbCkRanked from '@static/images/ab_ck_ranked.png';
import AbProfileRanked from '@static/images/ab_profile_ranked.png';
import AbSignIn from '@static/images/ab_sign_in.png';
import AbDiscordLogin from '@static/images/ab_discordlogin.png';
import AbMobileApp from '@static/images/ab_mobileapp.png';
import AbJoin from '@static/images/ab_join.png';
import AbHiringUx from '@static/images/ab_hiring_ux.png';
import AbGiftingValentines from '@static/images/ab_gifting_valentines.png';
import AbGiftingEaster from '@static/images/ab_gifting_easter.png';
import AbGiftingHalloween from '@static/images/ab_gifting_halloween.png';
import AbGiftingThanksgiving from '@static/images/ab_gifting_thanksgiving.png';
import AbGiftingChristmas from '@static/images/ab_gifting_christmas.png';
import AbGifting from '@static/images/ab_gifting.png';
import AbRush10Min from '@static/images/ab_rush_10_min.png';
import AbRushNoTurns from '@static/images/ab_rush_no_turns.png';
import { AudioManager, AudioType } from '@colonist/audio';
import { uiManagerEvents } from '../../../shared/scripts/EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../../../shared/scripts/store/subscription_overlay/subscriptionOverlayABTest.ts';
const showRushRulesDialogFromAd = ()=>showRushRulesDialog(()=>navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterBotGame, BotsMatchType.ColonistRush)));
export class UIPrivateAdController {
    startRefreshing() {
        if (this.showingAds) return;
        this.showingAds = true;
        this.createColonistAds();
        this.updateColonistAds();
        this.updateStoreAds();
        this.timer = setInterval(()=>{
            this.updateColonistAds();
            this.updateStoreAds();
        }, this.UPDATE_AD_DURATION);
    }
    updateColonistAds() {
        for (const imageElement of this.imageElements){
            this.ads = UIPrivateAdController.filterAds(this.ads);
            const adInformation = ArrayUtils.randomElementFromArray(this.ads);
            imageElement.src = adInformation.imageUrl;
            if (adInformation.rushVariant != undefined) sendRushAdImpression('inGameSide', adInformation.rushVariant);
            setElementOnClick(imageElement, ()=>{
                AudioManager.play(AudioType.Click);
                if (adInformation.rushVariant != undefined) sendRushAdClicked('inGameSide', adInformation.rushVariant);
                if (adInformation.clickAnalytic != undefined) {
                    const eventData = {
                        type: AnalyticEventType.ABTestClickAnalytics,
                        category: adInformation.giftingAd ? AnalyticEventCategory.GiftMembershipOverlay : AnalyticEventCategory.ABTestClickAnalytics,
                        floatValue: adInformation.clickAnalytic
                    };
                    void CA.sendAnalyticEvent(eventData);
                }
                if (adInformation.onClick != undefined) {
                    adInformation.onClick();
                    return;
                }
                const shouldOpenSubscriptionOverlay = adInformation.targetUrl == '/store#membership' && isSubscriptionOverlayVariant();
                if (shouldOpenSubscriptionOverlay) uiManagerEvents.premiumMembershipCheckAction();
                else navigateToPage(adInformation.targetUrl, true);
            });
        }
    }
    createColonistAds() {
        this.lobbyStoreAd.show();
        this.createAd(this.adElements.containerGameRight, 160, 600, '');
        this.createAd(this.adElements.containerGameLeft, 160, 600, '');
        UIPrivateAdController.hideRightExternalAds();
    }
    static hideRightExternalAds() {
        const webLayoutAdSpace = document.getElementById('web-layout-ad-space');
        if (webLayoutAdSpace == undefined) return;
        webLayoutAdSpace.querySelectorAll('.main_page_ad_300x250').forEach((element)=>element.classList.add('hidden'));
        webLayoutAdSpace.querySelectorAll('.main_page_ad_300x100').forEach((element)=>element.classList.add('hidden'));
    }
    updateStoreAds() {
        this.lobbyStoreAd.update();
    }
    createAd(container, width, height, id) {
        if (container === null) return;
        const imgElement = document.createElement('img');
        container.append(imgElement);
        imgElement.width = width;
        imgElement.height = height;
        imgElement.id = id;
        imgElement.style.cursor = 'pointer';
        this.imageElements.push(imgElement);
    }
    removeAds() {
        if (!this.showingAds) return;
        this.showingAds = false;
        this.lobbyStoreAd.hide();
        clearInterval(this.timer);
        for (const element of this.imageElements){
            var _element_parentElement;
            if (element.parentElement == undefined) continue;
            (_element_parentElement = element.parentElement) === null || _element_parentElement === void 0 ? void 0 : _element_parentElement.removeChild(element);
        }
        this.imageElements = [];
    }
    static filterAds(list) {
        var _ClientUserState_userState, _ClientUserState_userState1;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) list = list.filter((item)=>item.filterIfLoggedIn != true);
        if (UIUtilsEjsVariables.isUserOnDiscord) list = list.filter((item)=>item.filterIfDiscord != true);
        if ((_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.items.hasMembership()) list = list.filter((item)=>item.filterIfMembership != true);
        if (!UIUtilsEjsVariables.isUserOnDiscord) list = list.filter((item)=>item.filterIfNotDiscord != true);
        return list;
    }
    static accountLinkingAction() {
        var _ClientUserState_userState;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) {
            const profileRoute = `/profile/${ClientUserState.userState.username}#settings`;
            navigateToPage(profileRoute, true);
            return;
        }
        new ViewPopupLogin();
    }
    setGiftingAdBanners() {
        const targetUrl = '/store#gift';
        const holiday = HolidayDateUtils.getCurrentHoliday();
        switch(holiday){
            case 'valentines':
                {
                    this.ads.push({
                        imageUrl: AbGiftingValentines,
                        targetUrl: targetUrl,
                        giftingAd: true,
                        clickAnalytic: GiftMembershipMethod.InGameAd
                    });
                    break;
                }
            case 'easter':
                {
                    this.ads.push({
                        imageUrl: AbGiftingEaster,
                        targetUrl: targetUrl,
                        giftingAd: true,
                        clickAnalytic: GiftMembershipMethod.InGameAd
                    });
                    break;
                }
            case 'halloween':
                {
                    this.ads.push({
                        imageUrl: AbGiftingHalloween,
                        targetUrl: targetUrl,
                        giftingAd: true,
                        clickAnalytic: GiftMembershipMethod.InGameAd
                    });
                    break;
                }
            case 'thanksgiving':
                {
                    this.ads.push({
                        imageUrl: AbGiftingThanksgiving,
                        targetUrl: targetUrl,
                        giftingAd: true,
                        clickAnalytic: GiftMembershipMethod.InGameAd
                    });
                    break;
                }
            case 'christmas':
                {
                    this.ads.push({
                        imageUrl: AbGiftingChristmas,
                        targetUrl: targetUrl,
                        giftingAd: true,
                        clickAnalytic: GiftMembershipMethod.InGameAd
                    });
                    break;
                }
            default:
                break;
        }
        this.ads.push({
            imageUrl: AbGifting,
            targetUrl: targetUrl,
            giftingAd: true,
            clickAnalytic: GiftMembershipMethod.InGameAd
        });
    }
    constructor(adElements){
        this.ads = [
            {
                imageUrl: AbFullscreen,
                targetUrl: '/store#membership',
                filterIfDiscord: true
            },
            {
                imageUrl: AbMembership,
                targetUrl: '/store',
                filterIfMembership: true,
                onClick: ()=>{
                    if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
                    else navigateToPage('/store', true);
                }
            },
            // {imageUrl: AbContributor, targetUrl: '/careers'},
            {
                imageUrl: AbCkRanked,
                targetUrl: '/leaderboards/CitiesAndKnights4P/'
            },
            {
                imageUrl: AbRush10Min,
                targetUrl: '',
                onClick: showRushRulesDialogFromAd,
                rushVariant: '10min'
            },
            {
                imageUrl: AbRushNoTurns,
                targetUrl: '',
                onClick: showRushRulesDialogFromAd,
                rushVariant: 'noTurns'
            },
            {
                imageUrl: AbProfileRanked,
                targetUrl: '/leaderboards'
            },
            {
                imageUrl: AbSignIn,
                targetUrl: '',
                onClick: ()=>new ViewPopupLogin(),
                filterIfLoggedIn: true,
                filterIfDiscord: true
            },
            {
                imageUrl: AbDiscordLogin,
                targetUrl: '',
                onClick: ()=>new ViewPopupLogin(),
                filterIfLoggedIn: true,
                filterIfDiscord: true
            },
            {
                imageUrl: AbMobileApp,
                targetUrl: 'https://apps.apple.com/us/app/colonist-io/id6444831129'
            },
            {
                imageUrl: AbJoin,
                targetUrl: 'https://colonist.io/careers'
            },
            // {imageUrl: AbHiringPm, targetUrl: '/roles/product'},
            // {imageUrl: AbHiringQa, targetUrl: '/roles/qa-tester'},
            {
                imageUrl: AbHiringUx,
                targetUrl: '/careers'
            }
        ];
        this.UPDATE_AD_DURATION = 1000 * 60;
        this.imageElements = [];
        this.adElements = adElements;
        this.lobbyStoreAd = new UIHomepageAdView();
        this.setGiftingAdBanners();
    }
}
